import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AdminLayout from '../../components/admin/AdminLayout';

export default function Media() {
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <div className="p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <button 
              onClick={() => navigate('/admin/dashboard')}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              Back to Dashboard
            </button>
            <h1 className="text-3xl font-bold text-gray-900">Media Management</h1>
          </div>

          {/* Media content will go here */}
          <div className="bg-white rounded-lg p-6">
            <p className="text-gray-600">Media management features coming soon...</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}